export var iconSizes = {
  10: 168,
  9: 150,
  8: 132,
  7: 114,
  6: 96,
  5: 84,
  4: 72,
  3: 60,
  2: 48,
  1: 36,
  0: 30,
  '-1': 24
};